import { render } from "./PendingLiquidations.vue?vue&type=template&id=f630f9ce"
import script from "./PendingLiquidations.vue?vue&type=script&lang=js"
export * from "./PendingLiquidations.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__